import PropTypes from "prop-types";
import { Link } from "react-router";
import React from "react";

const Results = ({ items, seeAllUrl, seeAllContent, resultClass, title }) => {
  if (!items || !items.length) {
    return null;
  }

  var seeAll =
    seeAllUrl && seeAllContent ? (
      <Link className="highlight" to={seeAllUrl}>
        {seeAllContent}
      </Link>
    ) : null;

  return (
    <div className={resultClass}>
      <h5>{title}</h5>
      <ul className="result-list">{items}</ul>
      <div className="list-bottom">{seeAll}</div>
    </div>
  );
};

Results.propTypes = {
  items: PropTypes.array.isRequired,
  seeAllUrl: PropTypes.string,
  seeAllContent: PropTypes.string,
  resultClass: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Results;



// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/search-widget/quick-suggest/results.js